<div class="delete-modal-overlay" *ngIf="visible" (click)="onClose()">
  <div class="delete-modal" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="modal-header">
      <div class="header-content">
        <h2 class="modal-title">Delete Segment?</h2>
        <button class="close-button" (click)="onClose()">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13 1L1 13M1 1L13 13" stroke="#555963" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                
        </button>
      </div>
    </div>

    <!-- Content -->
    <div class="modal-content">
      <div class="content-text">
        <p class="description">
          This user segment will be removed and won't be available for future campaigns.
        </p>
        <p class="question">Do you want to continue?</p>
      </div>

      <!-- Warning Toast -->
      <div class="warning-toast">
        <div class="toast-content">
          <div class="toast-icon">
            <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3.43606 6.5678C5.44746 3.00869 6.45315 1.22913 7.83318 0.77104C8.59239 0.519028 9.41021 0.519028 10.1694 0.77104C11.5494 1.22913 12.5551 3.00869 14.5665 6.5678C16.5779 10.1269 17.5836 11.9065 17.2819 13.3565C17.116 14.1542 16.7071 14.8778 16.1138 15.4234C15.0355 16.4154 13.0241 16.4154 9.0013 16.4154C4.97851 16.4154 2.96711 16.4154 1.88877 15.4234C1.29553 14.8778 0.886627 14.1542 0.720655 13.3565C0.418964 11.9065 1.42466 10.1269 3.43606 6.5678Z" fill="#DA1E28"/>
                <path d="M8.99593 11.832H9.00342" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M9 9.33203L9 5.9987" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                
          </div>
          <div class="toast-text">
            <p class="warning-text">
              Note: This action will unlink this user segment from all campaigns to which it is connected.
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="modal-footer">
      <div class="footer-content">
        <div class="button-group">
          <button 
            type="button" 
            class="btn btn-secondary btn-large"
            (click)="onClose()">
            Cancel
          </button>
          <button 
            type="button" 
            class="btn btn-primary btn-large"
            [disabled]="loading"
            (click)="onConfirm()">
            <span *ngIf="!loading">Yes, Delete</span>
            <span *ngIf="loading" class="loading-content">
              <svg class="spinner" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="8" cy="8" r="6" stroke="currentColor" stroke-width="2" fill="none" stroke-dasharray="31.416" stroke-dashoffset="31.416">
                  <animate attributeName="stroke-dasharray" dur="2s" values="0 31.416;15.708 15.708;0 31.416" repeatCount="indefinite"/>
                  <animate attributeName="stroke-dashoffset" dur="2s" values="0;-15.708;-31.416" repeatCount="indefinite"/>
                </circle>
              </svg>
              Deleting...
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
